var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleStroke = function SvgGoogleStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.633 2.981 17.25 15.678M7 20.928 17.25 8.102M6 4.205v15.589a1.5 1.5 0 0 0 2.25 1.299l13.5-7.794c1-.578 1-2.021 0-2.598L8.25 2.906A1.5 1.5 0 0 0 6 4.206Z",
    stroke: "currentColor"
  })));
};

export default SvgGoogleStroke;